<template>
  <div class="pc-news-intro" v-show="editDaily">
    <div class="pc-news-intro-header">
      <h2>新闻正文</h2>
    </div>
    <div class="pc-news-intro-content">
      <div
        class="pc-news-intro-li"
        v-for="(item, index) in isDetail"
        :key="index"
      >
        <div class="pc-news-intro-li-left">
          <div class="pc-news-intro-li-left-top" v-if="index <= 9">
            0{{ index + 1 }}
          </div>
          <div class="pc-news-intro-li-left-top" v-if="index > 9">
            {{ index + 1 }}
          </div>
          <div class="pc-news-inside">
            <el-checkbox
              v-model="item.inside"
              :label="'非外链'"
              :key="'非外链'"
              :true-label="1"
              :false-label="0"
              @change="changeIsInside(item)"
            ></el-checkbox>
            <el-checkbox
              v-model="item.outside"
              :label="'外链'"
              :key="'外链'"
              :true-label="1"
              :false-label="0"
              @change="changeIsOutside(item)"
            ></el-checkbox>
          </div>
        </div>
        <div class="pc-news-intro-li-right">
          <div>
            <div class="pc-news-intro-li-right-content" v-if="item.inside">
              <h4>新闻ID</h4>
              <el-input
                v-model="item.relevance_id"
                placeholder="请输入新闻ID"
                @blur="changeNewsId(item)"
              ></el-input>
              <span v-if="item.numsShow">PV&nbsp;&nbsp;{{ item.nums }}</span>
            </div>
            <div class="pc-news-intro-li-right-link">
              <h4 v-if="item.outside">网址</h4>
              <el-input v-model="item.source_address" placeholder="请输入内容">
                <template slot="prepend">Http://</template>
              </el-input>
            </div>
          </div>
          <div>
            <h4>中文名</h4>
            <el-input
              v-model="item.chinese_title"
              placeholder="请输入中文标题"
            ></el-input>
          </div>
          <div>
            <h4>英文名</h4>
            <el-input
              v-model="item.english_title"
              placeholder="请输入英文标题"
            ></el-input>
          </div>
        </div>
        <div class="pc-news-intro-dedlete" @click="deleteNewsContentLi(index)">
          删除
        </div>
      </div>
      <div class="pc-news-intro-add">
        <div
          class="iconfont icon-tianjiaxinjiankong_huaban"
          @click="addContent"
        >
          添加分类
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsDetial_Api } from "../../../../apis/news.api";
import DeleteDialog from "../../../template/DeleteDialog";

export default {
  props: { isDetail: Array, editDaily: Boolean },
  components: {
    DeleteDialog,
  },
  data() {
    return {
      linkShow: false,
    };
  },
  methods: {
    getDailyContent() {
      return this.isDetail;
    },
    addContent() {
      this.isDetail.push({
        chinese_title: null,
        english_title: null,
        id: null,
        news_id: this.$route.query.id,
        relevance_id: null,
        source_address: null,
      });
    },
    deleteNewsContentLi(index) {
      this.isDetail.splice(index, 1);
    },
    changeIsInside(item) {
      item.outside = 0;
      this.linkShow = !this.linkShow;
    },
    changeIsOutside(item) {
      item.inside = 0;
      this.linkShow = !this.linkShow;
    },
    async changeNewsId(item) {
      let data = await getNewsDetial_Api(item.relevance_id);
      let addedNews = data.data;
      console.log(addedNews);
      if (addedNews.id) {
        item.relevance_id = addedNews.id;
        item.chinese_title = addedNews.chinese_title;
        item.english_title = addedNews.english_title;
        // item.nums = item.news.nums;
        item.source_address = "www.wupen.org/newsEvents/" + item.id;
        this.$global.success(this, "添加成功");
      } else {
        this.$global.error(this, "添加失败");
      }

      // item.newsId = item.news.id;
      // item.numsShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-news-intro {
  box-shadow: $boxshadow;
  padding: 30px 35px 10px;
  margin-top: 40px;
  .pc-news-intro-header {
    border-bottom: 1px solid #c0c0c0;
    > h2 {
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
    }
  }
  .pc-news-intro-content {
    width: 100%;
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
    /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #f7b500 !important;
      border-color: #f7b500 !important;
    }
    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #f7b500;
    }
    .pc-news-intro-li {
      display: flex;
      margin-top: 40px;
      padding-bottom: 43px;
      border-bottom: 1px solid #c0c0c0;
      position: relative;
      .pc-news-intro-li-left {
        background: #f5f7fa;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
        border-radius: 4px;
        border: 5px solid #ffffff;
        width: 200px;
        margin-right: 100px;
        //   height: 200px;
        .pc-news-intro-li-left-top {
          width: 101px;
          height: 110px;
          margin: 24px auto 32px 41px;
          font-size: 100px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #c4c9d4;
          line-height: 110px;
        }
        .pc-news-inside {
          margin-left: 26px;
          padding-bottom: 20px;
          /deep/ .el-checkbox__label {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #f7b500;
            line-height: 14px;
          }
        }
      }
      .pc-news-intro-li-right {
        flex: 1;
        width: 100%;
        h4 {
          width: 70px;
          min-width: 70px;
          text-align: right;
          margin-right: 10px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #434343;
          line-height: 40px;
        }
        > div {
          display: flex;
          margin-top: 20px;
          .pc-news-intro-li-right-content {
            display: flex;
            width: 50%;
            margin-right: 36px;
            /deep/ .el-input {
              width: 70%;
            }
            span {
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #f7b500;
              line-height: 40px;
              margin-left: 9px;
            }
          }
          .pc-news-intro-li-right-link {
            display: flex;
            width: 48%;
          }
        }
      }
      .pc-news-intro-dedlete {
        position: absolute;
        top: -30px;
        right: 0px;
        border-radius: 5px;
        border: 1px solid $schoolTagBorder;
        font-size: 14px;
        font-weight: 400;
        line-height: 14px;
        cursor: pointer;
        padding: 10px;
      }
    }
    .pc-news-intro-add {
      width: 200px;
      /deep/ .icon-tianjiaxinjiankong_huaban:before {
        display: inline-block;
        margin: 40px 10px 30px 36px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/news/components/NewsDetailIntro.vue